import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';

import { ICrisisActions, IThunkGetCrisisCalls } from '../types';

const onGetCrisisCalls: IThunkGetCrisisCalls = thunk(
  async ({ setCrisisCalls, setAllocatedClients }: Actions<ICrisisActions>, { clinicId }) => {
    const { crisisCalls = [], allocatedClients = [] } = await api.crisis
      .getCrisisCalls(clinicId)
      .then(r => r.data);

    setCrisisCalls(crisisCalls);
    setAllocatedClients(allocatedClients);

    return { crisisCalls, allocatedClients };
  },
);

export default onGetCrisisCalls;
